var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-pipeline-test2" }, [
    _c("h1", [_vm._v("Pipeline")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Follow the progress of your fundraising efforts and see which investors have shown interest in your offering."
      ),
    ]),
    _vm._v(" "),
    _vm.cur_user_id != 264
      ? _c("div", [
          _c("img", {
            staticStyle: {
              width: "100%",
              "max-width": "1280px",
              display: "block",
            },
            attrs: { src: "/images/pipeline_preview.png?t=2" },
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _c(
            "a",
            { staticClass: "pta-button", attrs: { href: "/account/calendar" } },
            [_vm._v("PROCEED TO BOOK A CALL WITH US")]
          ),
        ])
      : _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "pta-pipeline-sort" }, [
            _c("ul", [
              _c(
                "li",
                {
                  class:
                    _vm.pta_sort_by == "created"
                      ? _vm.pta_sort_dir == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.pta_sort_by = "created"
                        ? _vm.pta_sort_dir == "desc"
                          ? (_vm.pta_sort_dir = "asc")
                          : (_vm.pta_sort_dir = "desc")
                        : (_vm.pta_sort_dir = "asc")
                      _vm.pta_sort_by = "created"
                    },
                  },
                },
                [_c("span", [_vm._v("Date created")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.pta_sort_by == "name"
                      ? _vm.pta_sort_dir == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.pta_sort_by = "name"
                        ? _vm.pta_sort_dir == "desc"
                          ? (_vm.pta_sort_dir = "asc")
                          : (_vm.pta_sort_dir = "desc")
                        : (_vm.pta_sort_dir = "asc")
                      _vm.pta_sort_by = "name"
                    },
                  },
                },
                [_c("span", [_vm._v("Name")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.pta_sort_by == "value"
                      ? _vm.pta_sort_dir == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.pta_sort_by = "value"
                        ? _vm.pta_sort_dir == "desc"
                          ? (_vm.pta_sort_dir = "asc")
                          : (_vm.pta_sort_dir = "desc")
                        : (_vm.pta_sort_dir = "asc")
                      _vm.pta_sort_by = "value"
                    },
                  },
                },
                [_c("span", [_vm._v("Value")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.pta_sort_by == "close"
                      ? _vm.pta_sort_dir == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.pta_sort_by = "close"
                        ? _vm.pta_sort_dir == "desc"
                          ? (_vm.pta_sort_dir = "asc")
                          : (_vm.pta_sort_dir = "desc")
                        : (_vm.pta_sort_dir = "asc")
                      _vm.pta_sort_by = "close"
                    },
                  },
                },
                [_c("span", [_vm._v("Close date")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.pta_sort_by == "updates"
                      ? _vm.pta_sort_dir == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.pta_sort_by = "updates"
                        ? _vm.pta_sort_dir == "desc"
                          ? (_vm.pta_sort_dir = "asc")
                          : (_vm.pta_sort_dir = "desc")
                        : (_vm.pta_sort_dir = "asc")
                      _vm.pta_sort_by = "updates"
                    },
                  },
                },
                [_c("span", [_vm._v("Last updates")])]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    _vm.pta_sort_by == "state"
                      ? _vm.pta_sort_dir == "asc"
                        ? "active-asc"
                        : "active-desc"
                      : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.pta_sort_by = "state"
                        ? _vm.pta_sort_dir == "desc"
                          ? (_vm.pta_sort_dir = "asc")
                          : (_vm.pta_sort_dir = "desc")
                        : (_vm.pta_sort_dir = "asc")
                      _vm.pta_sort_by = "state"
                    },
                  },
                },
                [_c("span", [_vm._v("State")])]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-pipeline-campaigns" }, [
            _c("div", { staticClass: "pta-pipeline-campaign" }, [
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "pta-pipeline-statusline pta-pipeline-color-1 pta-pipeline-size-9",
                    class:
                      _vm.show_index == 1 ? "pta-pipeline-show-labels" : "",
                  },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _vm._m(12),
                  ]
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "pta-pipeline-icon-show",
                  class: _vm.show_index == 1 ? "pta-pipeline-icon-hide" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.show_index == 1
                        ? (_vm.show_index = 0)
                        : (_vm.show_index = 1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "pta-pipeline-button",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.selected_index == 1
                          ? (_vm.selected_index = 0)
                          : (_vm.selected_index = 1)
                      },
                    },
                  },
                  [_vm._v("View details")]
                ),
              ]),
              _vm._v(" "),
              _vm.selected_index == 1
                ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                    _vm._v(
                      "\n          No information available yet.\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-pipeline-campaign" }, [
              _vm._m(13),
              _vm._v(" "),
              _vm._m(14),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "pta-pipeline-statusline pta-pipeline-color-2 pta-pipeline-size-9",
                    class:
                      _vm.show_index == 1 ? "pta-pipeline-show-labels" : "",
                  },
                  [
                    _vm._m(15),
                    _vm._v(" "),
                    _vm._m(16),
                    _vm._v(" "),
                    _vm._m(17),
                    _vm._v(" "),
                    _vm._m(18),
                    _vm._v(" "),
                    _vm._m(19),
                    _vm._v(" "),
                    _vm._m(20),
                    _vm._v(" "),
                    _vm._m(21),
                    _vm._v(" "),
                    _vm._m(22),
                    _vm._v(" "),
                    _vm._m(23),
                    _vm._v(" "),
                    _vm._m(24),
                  ]
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "pta-pipeline-icon-show",
                  class: _vm.show_index == 1 ? "pta-pipeline-icon-hide" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.show_index == 1
                        ? (_vm.show_index = 0)
                        : (_vm.show_index = 1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "pta-pipeline-button",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.selected_index == 1
                          ? (_vm.selected_index = 0)
                          : (_vm.selected_index = 1)
                      },
                    },
                  },
                  [_vm._v("View details")]
                ),
              ]),
              _vm._v(" "),
              _vm.selected_index == 1
                ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                    _vm._v(
                      "\n          No information available yet.\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-pipeline-campaign" }, [
              _vm._m(25),
              _vm._v(" "),
              _vm._m(26),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "pta-pipeline-statusline pta-pipeline-color-3 pta-pipeline-size-9",
                    class:
                      _vm.show_index == 1 ? "pta-pipeline-show-labels" : "",
                  },
                  [
                    _vm._m(27),
                    _vm._v(" "),
                    _vm._m(28),
                    _vm._v(" "),
                    _vm._m(29),
                    _vm._v(" "),
                    _vm._m(30),
                    _vm._v(" "),
                    _vm._m(31),
                    _vm._v(" "),
                    _vm._m(32),
                    _vm._v(" "),
                    _vm._m(33),
                    _vm._v(" "),
                    _vm._m(34),
                    _vm._v(" "),
                    _vm._m(35),
                    _vm._v(" "),
                    _vm._m(36),
                  ]
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "pta-pipeline-icon-show",
                  class: _vm.show_index == 1 ? "pta-pipeline-icon-hide" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.show_index == 1
                        ? (_vm.show_index = 0)
                        : (_vm.show_index = 1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "pta-pipeline-button",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.selected_index == 1
                          ? (_vm.selected_index = 0)
                          : (_vm.selected_index = 1)
                      },
                    },
                  },
                  [_vm._v("View details")]
                ),
              ]),
              _vm._v(" "),
              _vm.selected_index == 1
                ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                    _vm._v(
                      "\n          No information available yet.\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-pipeline-campaign" }, [
              _vm._m(37),
              _vm._v(" "),
              _vm._m(38),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "pta-pipeline-statusline pta-pipeline-color-4 pta-pipeline-size-9",
                    class:
                      _vm.show_index == 1 ? "pta-pipeline-show-labels" : "",
                  },
                  [
                    _vm._m(39),
                    _vm._v(" "),
                    _vm._m(40),
                    _vm._v(" "),
                    _vm._m(41),
                    _vm._v(" "),
                    _vm._m(42),
                    _vm._v(" "),
                    _vm._m(43),
                    _vm._v(" "),
                    _vm._m(44),
                    _vm._v(" "),
                    _vm._m(45),
                    _vm._v(" "),
                    _vm._m(46),
                    _vm._v(" "),
                    _vm._m(47),
                    _vm._v(" "),
                    _vm._m(48),
                  ]
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "pta-pipeline-icon-show",
                  class: _vm.show_index == 1 ? "pta-pipeline-icon-hide" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.show_index == 1
                        ? (_vm.show_index = 0)
                        : (_vm.show_index = 1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "pta-pipeline-button",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.selected_index == 1
                          ? (_vm.selected_index = 0)
                          : (_vm.selected_index = 1)
                      },
                    },
                  },
                  [_vm._v("View details")]
                ),
              ]),
              _vm._v(" "),
              _vm.selected_index == 1
                ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                    _vm._v(
                      "\n          No information available yet.\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-pipeline-campaign" }, [
              _vm._m(49),
              _vm._v(" "),
              _vm._m(50),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "pta-pipeline-statusline pta-pipeline-color-5 pta-pipeline-size-9",
                    class:
                      _vm.show_index == 1 ? "pta-pipeline-show-labels" : "",
                  },
                  [
                    _vm._m(51),
                    _vm._v(" "),
                    _vm._m(52),
                    _vm._v(" "),
                    _vm._m(53),
                    _vm._v(" "),
                    _vm._m(54),
                    _vm._v(" "),
                    _vm._m(55),
                    _vm._v(" "),
                    _vm._m(56),
                    _vm._v(" "),
                    _vm._m(57),
                    _vm._v(" "),
                    _vm._m(58),
                    _vm._v(" "),
                    _vm._m(59),
                    _vm._v(" "),
                    _vm._m(60),
                  ]
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "pta-pipeline-icon-show",
                  class: _vm.show_index == 1 ? "pta-pipeline-icon-hide" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.show_index == 1
                        ? (_vm.show_index = 0)
                        : (_vm.show_index = 1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "pta-pipeline-button",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.selected_index == 1
                          ? (_vm.selected_index = 0)
                          : (_vm.selected_index = 1)
                      },
                    },
                  },
                  [_vm._v("View details")]
                ),
              ]),
              _vm._v(" "),
              _vm.selected_index == 1
                ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                    _vm._v(
                      "\n          No information available yet.\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-status" }, [
      _c("ul", [
        _c("li", [_c("span", [_vm._v("5")]), _vm._v("Active Deals")]),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("£5,000.00")]),
          _vm._v("Average Deal Value"),
        ]),
        _vm._v(" "),
        _c("li", [_c("span", [_vm._v("0%")]), _vm._v("Success Rate")]),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("2 "), _c("i", [_vm._v("Days")])]),
          _vm._v("Average Deal Lifespan"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("Sanchis Miguel")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [_vm._v("£1,000.00")]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("08.06.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Fact Sheet")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Presentation")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Team Bios")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Case Studies")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Financial Model")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Key Terms")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Market Reports")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("PropTech Admin")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [_vm._v("£1,000.00")]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("08.06.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Fact Sheet")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Presentation")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Team Bios")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Case Studies")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Financial Model")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Key Terms")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Market Reports")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("Jerry Meyer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [_vm._v("£1,000.00")]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("08.06.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Fact Sheet")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Presentation")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Team Bios")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Case Studies")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Financial Model")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Key Terms")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Market Reports")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("Lewis Johnson")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [_vm._v("£1,000.00")]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("08.06.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Fact Sheet")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Presentation")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Team Bios")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Case Studies")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Financial Model")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Key Terms")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Market Reports")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("Romeu Sanchis")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [_vm._v("£1,000.00")]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("08.06.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Fact Sheet")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Presentation")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Team Bios")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Case Studies")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Financial Model")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Key Terms")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Market Reports")])])])
  },
]
render._withStripped = true

export { render, staticRenderFns }